import { InboxIcon, LinkIcon, PlusIcon } from '@heroicons/react/24/outline';
import React from 'react';

import CLocalizedText from '../../../components/CLocalizedText';
import ActionLinkButton from '../../../components/dashboardContent/ActionLinkButton';
import Page from '../../../components/layout/Page';
import PageModule from '../../../components/layout/PageModule';
import XDResponsiveGridWrapper from '../../../components/layout/XDResponsiveGridWrapper';
import { PageRoutes } from '../../../enums/enums';
import CLocalizedTextString from '../../../components/CLocalizedTextString';

export default function FactsheetManagementIndex() {

  const newLink=CLocalizedTextString('fs.new.link');
  const allFsLinks=CLocalizedTextString('fs.all.links');
  const allInquiryLinks=CLocalizedTextString('fs.inquiry.links');
  
  return (
    <Page>
      <PageModule>
        <h1>
          <CLocalizedText dictKey={'pubFactsheetOutletIndexH1'} />
        </h1>
        <XDResponsiveGridWrapper>
          <ActionLinkButton label={newLink} to={PageRoutes.PUBLISHING_FS_NEW_LINK}>
            <PlusIcon />
          </ActionLinkButton>
          <ActionLinkButton label={allFsLinks} to={PageRoutes.PUBLISHING_FS_OVERVIEW_OUTLET}>
            <LinkIcon />
          </ActionLinkButton>
          <ActionLinkButton label={allInquiryLinks} to={PageRoutes.PUBLISHING_FS_INQUIRIES_OUTLET}>
            <InboxIcon />
          </ActionLinkButton>
        </XDResponsiveGridWrapper>
      </PageModule>
    </Page>
  );
}
